/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ExploreActiveitemRequest
 */
export interface ExploreActiveitemRequest {
  /**
   *
   * @type {string}
   * @memberof ExploreActiveitemRequest
   */
  sessionId: string
  /**
   *
   * @type {string}
   * @memberof ExploreActiveitemRequest
   */
  menuId: string
}

/**
 * Check if a given object implements the ExploreActiveitemRequest interface.
 */
export function instanceOfExploreActiveitemRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'menuId' in value

  return isInstance
}

export function ExploreActiveitemRequestFromJSON(
  json: any,
): ExploreActiveitemRequest {
  return ExploreActiveitemRequestFromJSONTyped(json, false)
}

export function ExploreActiveitemRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExploreActiveitemRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
    menuId: json['menuId'],
  }
}

export function ExploreActiveitemRequestToJSON(
  value?: ExploreActiveitemRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
    menuId: value.menuId,
  }
}
